<p-confirmDialog key="hallpass" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="MainDiv">
	<div>
		<caass-manual-selector-extended-info [AudienceMode]="AudienceMode" [SelectedPerson]="SelectedPerson" [FacilityID]="FacilityID">
		</caass-manual-selector-extended-info>
	</div>

	<!--Menu-->
	<div class="TopMargin">
		<h5>Recent Hall Passes (Last 20 History Records)</h5>

		<!--Table of Recent Hallpasses-->
		<div>
			<p-table
				#mydt
				[value]="lstHallpasses"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[paginator]="true"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedEntry"
				dataKey="HallpassID"
				(onFilter)="onHandleFilter($event)"
				(onSort)="onHandleSort($event)"
				(onRowSelect)="onRowSelect($event)"
				(onRowUnselect)="onRowUnselect($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 20]"
			>
				<!--Headers-->
				<ng-template pTemplate="header">
					<!--Column Names-->
					<tr style="height: 4rem">
						<th pSortableColumn="HallpassDate">Date<p-sortIcon field="HallpassDate"></p-sortIcon></th>
						<th pSortableColumn="StartTime">Time<p-sortIcon field="StartTime"></p-sortIcon></th>
						<th pSortableColumn="HallpassReasonDesc">Reason<p-sortIcon field="HallpassReasonDesc"></p-sortIcon></th>
					</tr>
				</ng-template>

				<!--Data-->
				<ng-template pTemplate="body" let-entry>
					<tr [pSelectableRow]="entry">
						<td *ngFor="let col of cols" style="font-weight: bold">
							{{ entry[col.field] }}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!--Buttons-->
		<div class="hp-Center TopMargin10">
			<button class="btn btn-primary" (click)="onAdd()">Add</button>
			<button class="btn btn-primary" (click)="onView()">View</button>
			<button class="btn btn-primary" (click)="onReprint()">Reprint</button>
		</div>

		<!--Error Message-->
		<div class="form-group TopMargin hp-Center">
			<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
				{{ errorMessage }}
			</div>
		</div>
	</div>
</div>
